varying vec2 vUv; 
varying vec3 vNormal; 
varying vec3 vPos; 
varying vec3 vWorldPos; 
uniform float u_fog;

#include "../../lights/ambientLight.glsl"
#include "../../lights/directionalLight.glsl"

void main()
{
        vec3 viewDir = normalize(cameraPosition - vWorldPos);

    // vec3 color = vec3(0.1, 0.1, 0.1);
    vec3 color = 	vec3(0.67, 0.54, 0.52);

    vec3 light = vec3(0.);
    light += light += ambientLight(vec3(1.0), 0.05);
       light +=  directionalLight(
        vec3(0.5, 0.5, 0.5),       //Color
        1.0,                       //Intensity
        vNormal,                   // normals
        vec3(0.0, 5.0, 3.0),        //light position
        viewDir,                   // viewDirection
        20.0                     // specular Power
    );

    color *= 0.2;
    color *= light;

    float alpha = vWorldPos.y+u_fog;
    alpha = clamp(alpha, 0., 1.);
    alpha = max(alpha, 0.0);

if (alpha < 0.) {
    discard;

} else {
    gl_FragColor = vec4(color, alpha);

}

}